import { /*Map,*/ fromJS } from "immutable";
import { handleActions, createAction } from "redux-actions";
import Restful from "lib/restful";
import { replaceSpaceWithHyphen } from "lib/textFilter";
import config from "lib/fr-config";
import { sleep } from "lib/commonUtil";

const WAIT_MILLISEC = config.storeModule.waitForLoadingMilliSec;
const UNIT_LENGTH = 9;

const SET_IS_LOADING = "searchForLounge/SET_IS_LOADING";
const SET_SEARCH_OPTION = "searchForLounge/SET_SEARCH_OPTION";
const INIT_TARGET_DATA_FOR_LOUNGE =
  "searchForLounge/INIT_TARGET_DATA_FOR_LOUNGE";
const SET_OUTFIT_LIST_FOR_LOUNGE = "searchForLounge/SET_OUTFIT_LIST_FOR_LOUNGE";
const EXPORT_TARGET_DATA_FOR_LOUNGE =
  "searchForLounge/EXPORT_TARGET_DATA_FOR_LOUNGE";
const INIT_EXPORTED_DATA = "searchForLounge/INIT_EXPORTED_DATA";
const INIT_ALL_DATA = "searchForLounge/INIT_ALL_DATA";

const setIsLoading = createAction(SET_IS_LOADING);
const setSearchOption = createAction(SET_SEARCH_OPTION);
const initTargetDataForLounge = createAction(INIT_TARGET_DATA_FOR_LOUNGE);
const setOutfitListForLounge = createAction(SET_OUTFIT_LIST_FOR_LOUNGE);
const exportTargetDataForLounge = createAction(EXPORT_TARGET_DATA_FOR_LOUNGE);
const initExportedData = createAction(INIT_EXPORTED_DATA);
const initAllData = createAction(INIT_ALL_DATA);

const getAdditionalType = input => {
  const { brand, color, tag } = input;
  const additionalType = !!brand
    ? "brand"
    : !!color
    ? "color"
    : !!tag
    ? "tag"
    : "nullType";
  const additionalValue =
    additionalType === "nullType" ? "nullValue" : input[additionalType];
  return { additionalType, additionalValue };
};

const getSearchState = ({ getState }) => {
  const searchState = getState().searchForLounge.toJS();
  return searchState;
};

const getSerachOption = ({ getState }) => {
  const searchState = getSearchState({ getState });
  const { category, gender, brand, color, tag } = searchState;
  return { category, gender, brand, color, tag };
};

const getIsLoading = ({ getState }) => {
  const searchState = getSearchState({ getState });
  const { isLoading } = searchState;
  return isLoading;
};

const isSameSearchOption = (optionA, optionB) => {
  const {
    category: categoryA,
    gender: genderA,
    brand: brandA,
    color: colorA,
    tag: tagA
  } = optionA;
  const {
    category: categoryB,
    gender: genderB,
    brand: brandB,
    color: colorB,
    tag: tagB
  } = optionB;
  if (
    categoryA === categoryB &&
    genderA === genderB &&
    brandA === brandB &&
    colorA === colorB &&
    tagA === tagB
  ) {
    return true;
  } else {
    return false;
  }
};

const getTargetDataForLounge = ({ getState, searchOption }) => {
  const { category, gender, brand, color, tag } = searchOption;
  const searchState = getSearchState({ getState });
  const { dataForLounge } = searchState;
  const { additionalType, additionalValue } = getAdditionalType({
    brand,
    color,
    tag
  });
  const targetData =
    dataForLounge &&
    dataForLounge[category] &&
    dataForLounge[category][additionalType] &&
    dataForLounge[category][additionalType][additionalValue] &&
    dataForLounge[category][additionalType][additionalValue][gender];
  return targetData;
};

const addNewListForLounge = async ({ dispatch, searchOption }) => {
  const { category, gender, brand, color, tag } = searchOption;
  const length = UNIT_LENGTH;
  const { additionalType, additionalValue } = getAdditionalType({
    brand,
    color,
    tag
  });
  const queryObj = { category, gender };
  switch (additionalType) {
    case "brand":
      queryObj[additionalType] = replaceSpaceWithHyphen(additionalValue);
      break;
    case "category":
    case "color":
    case "tag":
      queryObj[additionalType] = additionalValue;
      break;
    case "nullType":
    default:
      break;
  }
  const input = { queryObj, length };

  const { code, res, errInfo } = await Restful.getSearchedOutfitForGuestAPI(input);
  if (code === "error") {
    const errObj = Error("api error");
    errObj.errorValue = { ...errInfo };
    throw errObj;
  }

  const { list } = res;
  dispatch(setOutfitListForLounge({ searchOption, savedList: list }));

  /** Ga에 라운지에서의 검색결과는 기록 안하고 있다. 필요시 검색결과 전송하자.*/
};

const checkLoungeDataExist = ({ getState, searchOption }) => {
  const returnObj = { isExist: true };
  const targetData = getTargetDataForLounge({ getState, searchOption });
  if (!targetData || !targetData.isEnd) {
    returnObj.isExist = false;
  }
  return returnObj;
};

export const getListForLounge =
  ({ category, brand, color, tag, gender }) =>
  async (dispatch, getState) => {
    if (!category || !gender) {
      throw Error(`input type error => category:${category}, gender:${gender}`);
    }

    let isLoading = getIsLoading({ getState });

    while (isLoading) {
      await sleep(WAIT_MILLISEC);
      isLoading = getIsLoading({ getState });
    }

    const searchOption = { category, brand, color, tag, gender };

    dispatch(setIsLoading(true));
    dispatch(setSearchOption(searchOption));

    const { isExist } = checkLoungeDataExist({ getState, searchOption });
    if (!isExist) {
      dispatch(initExportedData());
      dispatch(initTargetDataForLounge(searchOption));
      try {
        await addNewListForLounge({ dispatch, searchOption });
      } catch (error) {
        dispatch(setIsLoading(false));
        throw error;
      }
    }

    const nowSearchOption = getSerachOption({ getState });
    if (isSameSearchOption(searchOption, nowSearchOption)) {
      dispatch(exportTargetDataForLounge(searchOption));
    }

    dispatch(setIsLoading(false));
  };

export const deleteAllData = () => (dispatch, getState) => {
  dispatch(initAllData());
};

const initialState = fromJS({
  dataForLounge: {},
  /*
  dataForLounge 의 구조.
  data: {
    [category]: {
      [brand || color || tag || "nullType"]: {
        [value || "nullValue"]: {
          [gender]: {
            savedList: [],
            isEnd: true
          }
        }
      }
    }
  },
  */
  category: null,
  brand: null,
  color: null,
  tag: null,
  gender: null,

  outfitList: [],
  isEnd: false,
  isLoading: false
});

export default handleActions(
  {
    [SET_IS_LOADING]: (state, action) => {
      const isLoading = action.payload;
      return state.set("isLoading", fromJS(isLoading));
    },
    [SET_SEARCH_OPTION]: (state, action) => {
      const { category, brand, color, tag, gender } = action.payload;
      return state
        .set("category", fromJS(category))
        .set("tag", fromJS(tag))
        .set("color", fromJS(color))
        .set("brand", fromJS(brand))
        .set("gender", fromJS(gender));
    },
    [INIT_TARGET_DATA_FOR_LOUNGE]: (state, action) => {
      const { category, gender, brand, color, tag } = action.payload;
      const { additionalType, additionalValue } = getAdditionalType({
        brand,
        color,
        tag
      });
      const newData = {
        savedList: [],
        isEnd: false
      };
      return state.setIn(
        ["dataForLounge", category, additionalType, additionalValue, gender],
        fromJS(newData)
      );
    },
    [SET_OUTFIT_LIST_FOR_LOUNGE]: (state, action) => {
      const { searchOption, savedList } = action.payload;
      const { category, gender, brand, color, tag } = searchOption;
      const { additionalType, additionalValue } = getAdditionalType({
        brand,
        color,
        tag
      });
      const newData = {
        savedList,
        isEnd: true
      };
      return state.setIn(
        ["dataForLounge", category, additionalType, additionalValue, gender],
        fromJS(newData)
      );
    },
    [EXPORT_TARGET_DATA_FOR_LOUNGE]: (state, action) => {
      const { category, gender, brand, color, tag } = action.payload;
      const { dataForLounge } = state.toJS();
      const { additionalType, additionalValue } = getAdditionalType({
        brand,
        color,
        tag
      });
      const { savedList } =
        dataForLounge[category][additionalType][additionalValue][gender];
      return state
        .set("outfitList", fromJS(savedList))
        .set("isEnd", fromJS(true));
    },
    [INIT_EXPORTED_DATA]: (state, action) => {
      const { outfitList, isEnd } = initialState.toJS();
      return state
        .set("outfitList", fromJS(outfitList))
        .set("isEnd", fromJS(isEnd));
    },
    [INIT_ALL_DATA]: (state, action) => {
      return initialState;
    }
  },
  initialState
);
